import { ETheme, EThemeBackground } from '@/common/entity/Enum';
import styled from 'styled-components';

export const ResourceSelectedBaseWrapper = styled.div<{$maxHeight?: number}>`
  width: 100%;
  && .rc_accordionPanel_content {
    max-height: ${(props) => `${props.$maxHeight || 128}px !important`};
    overflow-y: auto !important;
  }
  .nodata {
    margin-bottom: 15px;
  }
`;

export const ResourceInfoWrapper = styled.div<{$isLastChild?: boolean}>`
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: ${props => props.$isLastChild ? "0px" : "8px"}; 
  .SectionResourcesWrapper {
    margin-bottom: ${props => props.$isLastChild ? "0px" : "8px"} !important;
  }
`;

export const StickyElementWrapper = styled.div<{ $theme?: string }>`
  height: 40px;
  margin-left: -2px;
  overflow-x: hidden;
  position: sticky;
  bottom: 0;
  padding: 0px 15px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background: ${props => props.$theme === ETheme.Dark ? EThemeBackground.Dark : EThemeBackground.Light};
`;

export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -6px;
`;
